import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    // Listen at document level to catch all variant update events
    document.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    // Always update for combined listings - be more permissive
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    // Try multiple selectors to find the price container in the fetched HTML
    let newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    if (!newPrice) {
      // Fallback: look for any price container in the HTML
      newPrice = event.detail.data.html.querySelector('[ref="priceContainer"]');
    }
    if (!newPrice) {
      // Another fallback: look for price elements directly
      newPrice = event.detail.data.html.querySelector('.price-container');
    }

    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) {
      return;
    }

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      const clonedNewPrice = newPrice.cloneNode(true);
      currentPrice.replaceWith(clonedNewPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
